import {
    IconAccess,
    IconActivation,
    IconAudit,
    IconFlag,
    IconMigration,
    IconOrgs,
    IconOverview,
} from '@shared/ui';

import type { ComponentType, SVGProps } from 'react';

export type NavItem = {
    label: string;
    href: string;
    icon: ComponentType<SVGProps<SVGSVGElement>>;
    /** Rendered muted + non-navigable until the screen exists. */
    disabled?: boolean;
};

export type NavGroup = {
    label?: string;
    items: NavItem[];
};

/** Sidebar structure — matches the Backoffice mockup. */
export const NAV_GROUPS: NavGroup[] = [
    {
        items: [{ label: 'Overview', href: '/overview', icon: IconOverview }],
    },
    {
        label: 'Configuration',
        items: [
            // One entry, not three: Flags, Components and Products are tabs of
            // one screen, because they are one question — what exists on the
            // platform. `Add-ons` used to sit beside this and is now the
            // Products tab; the nav cannot carry both words at once.
            //
            // No counts in this sidebar. The flags badge used to live here and
            // moved onto the catalog's own tabs: a number beside `Catalog`
            // would have to stand for three things at once, and beside `Flags`
            // it means flags.
            { label: 'Catalog', href: '/catalog/flags', icon: IconFlag },
        ],
    },
    {
        label: 'Tenants',
        items: [
            { label: 'Clients', href: '/clients', icon: IconOrgs },
            { label: 'Feature Activation', href: '/activation-tracking', icon: IconActivation },
            { label: 'Salesforce migration', href: '/migrations', icon: IconMigration },
            { label: 'Audit Log', href: '/audit', icon: IconAudit },
        ],
    },
    {
        label: 'System',
        items: [{ label: 'Access & Roles', href: '/access', icon: IconAccess, disabled: true }],
    },
];
